import { faqItems, howWeCompareItems } from '../../content/modalsContent';

const customerHelpContent = {
  title: 'Kunnen wij je helpen?',
  imageUrl:
    'https://comparators.kizi.nl/cb/assets/images/helpdesk-beeld-1200px.jpg',
  subtitle: 'Neem contact met ons op',
  modals: {
    faq: {
      buttonLabel: 'Veelgestelde vragen',
      buttonIcon: 'comment',
      title: 'Veelgestelde vragen',
      items: faqItems,
    },
    howWeCompare: {
      buttonLabel: 'Hoe vergelijken wij?',
      buttonIcon: 'checked-doc',
      title: 'Hoe vergelijken wij?',
      items: howWeCompareItems,
    },
  },
  contacts: [
    {
      icon: 'user-headset',
      label: '088 - 90 01 771',
      href: '0889001771',
      text: 'ma - vr 09.00 – 20.00 & za 10.00 – 17.00',
      type: 'phone',
    },
    {
      icon: 'envelope',
      prelabel: 'stuur een',
      label: 'e-mail',
      href: 'consumentenbond@klantenservice.breedbandwinkel.nl',
      type: 'mail',
    },
  ],
};

export default customerHelpContent;
